import script from "./DetalleFormacion.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleFormacion.vue?vue&type=script&setup=true&lang=js"

import "./DetalleFormacion.vue?vue&type=style&index=0&id=22618b8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22618b8b"]])

export default __exports__